<template>
  <div class="container">
              <div >
                    <div class="containerBottom">
                      <div class="left">
                        <!-- <div class="title">{{ detailData.tltle }}</div> -->
                        
                        <div style="margin-top: 10px">
                            <span style="font-weight: 700;color: black;font-size: 24px;">{{detailData.title}}</span>
                        </div>
                        <div  class="lineBox">
                          <div style="width: 60%">申请人：{{detailData.companyName}}公司/{{detailData.deptName}}部门/{{detailData.userName}}</div>
                          <div style="width: 40%">申请时间：{{detailData.updateTime}}</div>
                        </div>
                        <div class="lineBox">
                            <!-- <span>{{ detailData.companyName }}公司/部门{{ detailData.deptName }}</span> -->
                            <!-- <span v-if="detailData.BaseInformation.isFeeDept" style="font-weight: 700;color: black;margin-left: 20px">费用归属公司/部门: 
                                    <span style="font-weight: 400;margin-left: 5px">{{detailData.relateDept}}</span></span> -->
                            <div style="width: 60%" >申请编号：{{ detailData.applyCode }}</div>
                            <div style="width: 50%"  v-if="detailData.serialNo">交易流水号: {{ detailData.serialNo }}</div>

                            <!-- <div style="width: 50%">付款类别：{{ detailData.BaseInformation.type }}</div> -->
                        </div>
                        <div class="lineBox">
                            <div style="width: 40%"  v-if="detailData.paymentBillNo">付款单号：{{ detailData.paymentBillNo}}</div>

                        </div>
                      </div>
                      <div class="right">
                        <div class="containerBox">
                            <div class="containerLeft">
                                <div class="first">收款账户</div>
                                <div class="second">
                                    <div>户名： {{detailData.BaseInformation.account_information.reimbursement_account.name}}</div>
                                    <div>账号： {{detailData.BaseInformation.account_information.reimbursement_account.accountNum}}</div>
                                    <div>
                                        <span  v-if="detailData.BaseInformation.account_information.reimbursement_account.bank">
                                          银行： {{detailData.BaseInformation.account_information.reimbursement_account.bank}}
                                        </span>
                                        <span v-if="detailData.BaseInformation.account_information.reimbursement_account.address">
                                        地址： {{detailData.BaseInformation.account_information.reimbursement_account.address}}
                                        </span>
                                    </div>
                                      <div v-if="detailData.BaseInformation.account_information.reimbursement_account.branchBank">
                                      银行支行： {{detailData.BaseInformation.account_information.reimbursement_account.branchBank}}
                                      </div>
                                </div>
                            </div>
                          <div class="containerRight">
                            <!-- 驳回 -->
                            <img v-if="this.detailData.result == 3" src="../../../../public/images/reject.png" alt="">
                            <!-- 通过 -->
                            <img v-if="this.detailData.result == 2" src="../../../../public/images/pass.png" alt="">
                            <!-- 审批中 -->
                            <img v-if="this.detailData.result == 1" src="../../../../public/images/examine.png" alt="">
                            <!-- 撤销 -->
                            <img v-if="this.detailData.result == 4" src="../../../../public/images/stop.png" alt="">
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="containerBottom boxBorder">
                        <div>
                          <!-- 费用归属部门：{{detailData.relateDept}} -->
                          </div>
                          <div  style="width: 50%;display: flex;justify-content: space-between;">
                            <div>付款总金额：<span style="color: rgb(247, 126, 28);">{{detailData.projectMoney}}</span>元整 （{{detailData.capitalMoney}}整）</div>
                            <div >
                              <!-- <a-button  @click="rePush" style="color: rgb(24, 144, 255)" v-if="detailData.addPaymentOrder && !detailData.paymentBillNo" > 重新推送 </a-button> -->
                              <a-button  @click="rePush(1)" style="color: rgb(24, 144, 255)" v-if="detailData.addPaymentOrder && !detailData.paymentBillNo" > 重新推送 </a-button>

                              <a-button  @click="rePush(2)" v-if="detailData.addSingleTransfer && !detailData.serialNo" style="color: rgb(24, 144, 255)" > 转账单推送 </a-button>


                              </div>
                            <!-- v-if="detailData.addPaymentOrder && !detailData.paymentBillNo" -->
                            <!--v-if="detailData.BaseInformation.addPaymentOrder && detailData.BaseInformation.paymentBilINo "-->
                          </div>
                    </div>
              </div>
                  <!-- 中间部分 -->
              <div class="containerCenter ">
                    <div class="left">
                        <!-- 关联项目信息 v-if="detailData.BaseInformation.isCheckInformation"-->
                        <div class="box"  v-if="detailData.BaseInformation.isCheckInformation || detailData.BaseInformation.isReceived">
                            <div class="title">
                                <span>关联项目信息</span>
                            </div>
                            <div class="centerBox">
                                <a-table :data-source="detailData.BaseInformation.information_relate" bordered :pagination="false">
                                    <a-table-column key="project_name" title="项目名称" data-index="project_name" style="color: red" />
                                    <a-table-column key="project_code" title="项目编号" data-index="project_code" />
                                    <a-table-column key="projece_pay" title="项目金额（元）" data-index="projece_pay" />
                                    <a-table-column key="amount" :title="detailData.BaseInformation.isCheckInformation? '已付金额':'项目已回款（元）'" data-index="amount" />
                                    <a-table-column key="projece_fee" title="报销费用（元）" data-index="projece_fee" v-if="detailData.BaseInformation.isFindProject"/>
                                </a-table>
                            </div>
                        </div>
                        <!-- 付款详情 v-if="detailData.detail"-->
                        <div class="box" v-if="detailData.detail">
                            <div class="title">
                                <span>付款详情</span>
                            </div>
                            <div class="centerBox">
                                    <a-collapse :expand-icon-position="expandIconPosition">
                                      <a-collapse-panel :key="index" v-for="(item, index) in detailData.detail" >
                                          <template slot="header">
                                              <div class="expensesTop">
                                                  <span style="font-weight: 700;">{{item.control_name}}</span>
                                                  <div class="xuxian"></div>
                                                  <div style="margin: 0 5px; width: 30%"> 
                                                      <span>金额为 <span style="color: rgb(247, 126, 28);">{{item.value}}</span>元整</span>
                                                  </div>
                                              </div>
                                          </template>
                                          <div class="bottom">
                                            <div v-for="(item1, index1) in item.array" :key="index1">
                                              <!-- <div>{{item1}}</div> -->
                                              <div v-if="item1" style="font-weight: 700; margin: 7px">{{ item1.label }}</div>
                                            <!-- 差旅费 -->
                                              <div v-if="item1" style="margin: 5px">
                                                    <div v-if="item1.type == 'array' && item1['travelData'] ">
                                                        <div class="travelBoxTop">
                                                          <div  style="width: 45%; border-right: 1px solid #dedfdf;">
                                                              <div class="travelContetTop">出差起始地</div>
                                                              <div class="travelContetBottom">
                                                                  <span>{{item1.travelData.location_start}} ~ {{item1.travelData.location_end}}</span>
                                                              </div>
                                                          </div>
                                                          <div  style="width: 15%; border-right: 1px solid #dedfdf;">
                                                              <div class="travelContetTop">天数</div>
                                                              <div class="travelContetBottom">
                                                                <span>{{item1.travelData.days}}</span>
                                                              </div>
                                                          </div>
                                                          <div  style="width: 40%;">
                                                              <div class="travelContetTop">起止日期</div>
                                                              <div class="travelContetBottom">
                                                                <span>{{item1.travelData.time_start}} ~ {{item1.travelData.time_end}}</span>
                                                              </div>
                                                          </div>
                                                        </div>
                                                        <div class="travelBoxCenter borderStyle borderBottom">
                                                            <div style="width: 50%; border-right: 1px solid #dedfdf; ">
                                                                <div class="travelContetTop">异地交通费</div>
                                                              <div class="layoutbox">
                                                                    <div style="width: 33.3%;">
                                                                        <div class="travelContetTop ">飞机</div>
                                                                        <div  class="travelContetBottom">
                                                                          <span>{{item1.travelData.plane_fee}}</span>
                                                                        </div>
                                                                    </div>
                                                                    <div style="width: 33.3%;">
                                                                        <div class="travelContetTop borderStyle">火车</div>
                                                                        <div  class="travelContetBottom borderStyle">
                                                                          <span>{{item1.travelData.train_fee}}</span>
                                                                        </div>
                                                                    </div>
                                                                    <div style="width: 33.4%;">
                                                                        <div class="travelContetTop">大巴</div>
                                                                        <div  class="travelContetBottom">
                                                                          <span>{{item1.travelData.bus_fee}}</span>
                                                                        </div>
                                                                    </div>
                                                              </div>
                                                            </div>
                                                            <div style="width: 50%; ">
                                                                <div class="travelContetTop">同城交通费</div>
                                                                <div class="layoutbox">
                                                                    <div style="width: 33.3%;">
                                                                    <div class="travelContetTop ">地铁</div>
                                                                    <div  class="travelContetBottom">
                                                                      <span>{{item1.travelData.subway_fee}}</span>
                                                                    </div>
                                                                </div>
                                                                <div style="width: 33.3%;">
                                                                    <div class="travelContetTop borderStyle">公交</div>
                                                                    <div  class="travelContetBottom borderStyle">
                                                                      <span>{{item1.travelData.transit_fee}}</span>
                                                                    </div>
                                                                </div>
                                                                <div style="width: 33.4%;">
                                                                    <div class="travelContetTop">出租</div>
                                                                    <div  class="travelContetBottom">
                                                                      <span>{{item1.travelData.taxi_fee}}</span>
                                                                    </div>
                                                                </div>
                                                              </div>
                                                            </div>
                                                        </div>
                                                        <div class="travelCenter borderStyle borderBottom">
                                                            <div class="contener">住宿费</div>
                                                            <div class="travelContetBottom contenerBox">
                                                              <span>{{item1.travelData.live_fee}}</span>
                                                            </div>
                                                            <div class="contener">出差补贴</div>
                                                            <div class="travelContetBottom">
                                                              <span>{{item1.travelData.travel_fee}}</span>
                                                            </div>
                                                        </div>
                                                        <div class="travelCenter borderStyle borderBottom">
                                                            <div class="contener">其他费用</div>
                                                            <div class="travelContetBottom contenerBox">
                                                              <span>{{item1.travelData.other_fee}}</span>
                                                            </div>
                                                            <div class="contener">小计（元）</div>
                                                            <div class="travelContetBottom">
                                                              <span>{{item1.travelData.total}}</span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div v-else style="padding: 10px 5px">{{ item1.value }}</div>

                                                </div>
                                            </div>
                                          </div>
                                      </a-collapse-panel>
                                    </a-collapse>
                            </div>
                        </div>
                        <!-- 发票信息 v-if="detailData.BaseInformation.isCheckBill"-->
                        <div class="box" v-if="detailData.BaseInformation.isCheckBill">
                            <div class="title">
                              <span>发票信息</span>
                            </div>
                            <div class="centerBox">
                              <a-table
                                :data-source="detailData.BaseInformation.bill_information"
                                ref="bodyTop"
                                :pagination="false"
                                bordered
                                :loading="loading"
                                @change="handleTableChange"
                              >
                                <a-table-column key="bill_code" data-index="bill_code" title="发票代码" />
                                <a-table-column key="bill_number" data-index="bill_number" title="发票号码" />
                                <a-table-column key="bill_money" data-index="bill_money" title="发票金额(元)" />
                                <a-table-column key="bill_date" data-index="bill_date" title="开票日期" />
                                <a-table-column key="bill_type" title="发票类型" data-index="bill_type" />
                                <a-table-column key="action" title="操作">
                                  <template slot-scope="text, record, index">
                                    <span>
                                      <a @click="downFile(index)">下载</a>
                                    </span>
                                  </template>
                                </a-table-column>
                              </a-table>
                            </div>
                        </div>
                        <!-- 关联审批信息 v-if="detailData.BaseInformation.isRelationAudit == true || detailData.BaseInformation.isRelationPurchase == true"-->
                        <div class="box" v-if="detailData.BaseInformation.isRelationAudit == true || detailData.BaseInformation.isRelationPurchase == true">
                          <div class="title">
                            <span>关联审批信息</span>
                          </div>
                          <div class="centerBox">
                            <!-- v-if="detailData.BaseInformation.isRelationAudit" -->
                            <a-table
                              :data-source="detailData.BaseInformation.approvalData"
                              ref="approvalDataRef"
                              :pagination="false"
                              bordered
                              :loading="loading"
                              @change="handleTableChange"
                              v-if="detailData.BaseInformation.isRelationAudit"
                            
                            >
                              <a-table-column key="applyCode" title="申请单号" data-index="applyCode" />
                              <a-table-column key="processName" title="申请标题" data-index="processName" />
                              <a-table-column key="applyer" title="申请人" data-index="applyer" />
                              <a-table-column key="applyerTime" title="申请时间" data-index="applyerTime" />
                              <a-table-column key="result" title="审批结果" data-index="result">
                                <template scope="text,record">
                                  <a-tag :color="result_apply[record.result].color">
                                    {{ result_apply[record.result].txt }}
                                  </a-tag>
                                </template>
                              </a-table-column>
                            </a-table>
                            <!-- v-if="detailData.BaseInformation.isRelationPurchase == true" -->
                            <a-table
                              :data-source="detailData.BaseInformation.purchaseData"
                              ref="receiptDataRef"
                              :pagination="false"
                              bordered
                              :loading="loading"
                              @change="handleTableChange"
                              v-if="detailData.BaseInformation.isRelationPurchase == true" 
                            
                            >
                              <a-table-column key="applyCode" title="申请单号" data-index="applyCode" />
                              <a-table-column key="name" title="物品名称" data-index="name" />
                              <a-table-column key="model" title="规格型号" data-index="model" />
                              <a-table-column key="amount" title="数量" data-index="amount" />
                              <a-table-column key="unit" title="单位" data-index="unit" />
                              <a-table-column key="isInvalid" title="申购状态" data-index="isInvalid">
                                <template scope="text,record">
                                  <a-tag class="span" :color="record.isInvalid == 1 ? 'red' : 'green'">
                                    {{ record.isInvalid == 1 ? '作废' : '正常' }}
                                  </a-tag>
                                </template>
                              </a-table-column>
                              <a-table-column key="result" title="审批结果" data-index="result">
                                <template scope="text,record">
                                  <a-tag :color="result_apply[record.result].color">
                                    {{ result_apply[record.result].txt }}
                                  </a-tag>
                                </template>
                              </a-table-column>
                            </a-table>
                          </div>
                        </div>
                        <!-- 申请备注信息 -->
                        <div class="box" >
                            <div class="title">
                              <span>申请备注信息</span>
                            </div>
                            <div style="padding: 5px 10px;background-color: rgb(230, 228, 228);margin-top: 10px;">
                              <div style="font-weight:700; margin: 10px 0;">备注说明</div>
                              <div>{{detailData.BaseInformation.remark}}</div>
                              <div style="font-weight:700; margin: 10px 0;">特殊备注(此信息不会进行打印)</div>
                              <div>{{detailData.BaseInformation.tips}}</div>
                            </div>
                        </div>
                          <div class="box" >
                            <div class="title">
                              <span>代理信息</span>
                            </div>
                            <div style="padding: 5px 10px;background-color: rgb(230, 228, 228);margin-top: 10px;">
                              <div style="font-weight:700; margin: 10px 0;" v-if="!detailData.agentName">
                                  <span style="margin-right: 10px;">是否代为报销:</span>
                                    <a-radio-group name="radioGroup" :default-value="0" disabled>
                                      <a-radio :value="0"> 否  </a-radio>
                                    </a-radio-group>
                              </div>
                              <div style="font-weight:700; margin: 10px 0;" v-if="detailData.agentName">
                                  <span style="margin-right: 10px;">实际报销人：:</span>{{detailData.agentName}}
                              </div>
                            </div>
                        </div>
                        <!-- 图片文件 -->
                        <div class="box" >
                          <div class="title">
                            <span>附件详情（除发票以外的凭证附件）</span>
                          </div>
                          <div style="margin-top: 5px;">
                            <div>
                                <div>
                                  <span>图片：</span>
                                </div>
                              <!-- <a-collapse :expand-icon-position="expandIconPosition">
                                  <a-collapse-panel >
                                      <template slot="header">
                                          <div style="margin-bottom: 10px">图片:</div>
                                      </template> -->
                                <div class="contentBox">
                                      <div class="img_center"
                                        v-for="(item, index) in detailData.certificate" :key="index"
                                      >
                                          <div>
                                              <img :src="item.preUrl" @click="show_img(index, detailData.certificate)" />
                                              <div class="timeBox">{{item.createdTime}}</div>
                                          </div>
                                      </div>
                                      <preview ref="preview" />
                                </div>
                                  <!-- </a-collapse-panel>
                              </a-collapse> -->
                              <!-- <a-collapse :expand-icon-position="expandIconPosition">
                                    <a-collapse-panel >
                                        <template slot="header">
                                            <div style="margin-bottom: 10px">文件:</div>
                                        </template> -->
                            </div>
                            <div >
                                  <div class="title">
                                    <span>文件：</span>
                                  </div>
                                
                                  <div  class="contentBox">
                                      <a-table
                                      :data-source="detailData.appendix"
                                      :pagination="false"
                                      bordered
                                    >
                                      <a-table-column key="isInvalid" title="文件" data-index="isInvalid">
                                        <template scope="text,record">
                                            <span @click="previewFile(record)" style="color: #409EFF;">{{record.name}}</span>
                                        </template>
                                      </a-table-column>
                                      <a-table-column key="createdTime" title="时间" data-index="createdTime" />
                                    </a-table>

                                        <!-- <div  @click="previewFile(item)" style="width: 23%;margin-left: 5px; float: left;height: 60px;"
                                            v-for="(item, index) in detailData.appendix" :key="index">
                                                <div style="color: #409EFF;">{{ item.name }} </div>  
                                                <div>{{item.createdTime}}</div>
                                        </div> -->
                                  </div>
                            </div>
                                    <!-- </a-collapse-panel>
                              </a-collapse> -->
                          </div>
                        <!-- <div class="contentBox">
                          <div class="leftBox">
                              <div style="margin-bottom: 10px">图片:</div>
                              <div class="img_center"
                                v-for="(item, index) in detailData.certificate" :key="index"
                              >
                                    <div style="margin: 10px;">
                                      <img :src="item.preUrl" @click="show_img(index, detailData.certificate)" />
                                      <div style="margin-top: 60px;">{{item.createdTime}}</div>
                                    </div>
                              </div>
                              <preview ref="preview" />

                          </div>
                          <div class="rightBox">2</div>
                        </div> -->
                        </div>
                        <!-- 评论信息 -->
                        <div class="box">
                            <div class="title">
                              <span>申请备注信息</span>
                            </div>
                            <div style="margin-top: 10px;">
                              <a-table :data-source="processData" bordered :pagination="false">
                                  <a-table-column key="comment" title="评论详情" data-index="comment" />
                                  <a-table-column key="createTime" title="评论时间" data-index="createTime" />
                                  <a-table-column key="userName" title="评论人" data-index="userName" />
                                  <a-table-column key="action" title="操作" width="200px" fixed="right" >
                                      <template slot-scope="text, record">
                                        <span>
                                          <a @click.stop="delTem(record)" :disabled="record.delFlag == 1">撤回</a>
                                        </span>
                                      </template>
                                  </a-table-column>
                              </a-table>

                            </div>
                            <a-divider style="50%; color: dedfdf;"> 已经到底了</a-divider>
                        </div>
                        
                  </div>
                  <div class="right">
                      <div class="box">
                            <div class="title">
                              <span>审批信息</span>
                            </div>
                            <div>
                                  <a-steps direction="vertical" :current="resultId"  status="error" v-if="isError == 1">
                                      <a-step  v-for="(item, index) in processList" :key="index">
                                          <template slot="title">
                                              <div v-if="item">
                                                <span class="red">{{item.name}}</span>
                                                <span style="margin-left: 10px;"  v-if="item.flag == true && item.type != 'end' && item.type != 'start' ">审批结果：<span :style="{color: resultColor[item.result] }">{{resultList[item.result]}}</span></span>
                                              </div>
                                          </template>
                                          <template slot="description">
                                              <div class="red">{{item.auditor}}</div>
                                              <div v-if="item.comment">审批建议：{{item.comment}}</div>
                                          </template>
                                          <a-icon v-if="item.result == 0 && item.flag == true " type="check-circle" slot="icon"></a-icon>
                                          <!-- 通过审批 -->
                                          <a-icon v-if="item.result == 2 " type="check-circle" slot="icon"></a-icon>
                                          <!-- 驳回 -->
                                          <a-icon v-if="item.result == 3 || item.result == 4 || item.result == 6 " type="close-circle" slot="icon"></a-icon>
                                          <!-- 审批中 -->
                                          <a-icon  v-if="item.result == 1 && item.flag == true " type="clock-circle" slot="icon"></a-icon>
                                          <a-icon  v-if="item.result == 0 && item.flag == false " type="clock-circle" slot="icon"></a-icon>
                                          <!-- <a-icon   v-else type="clock-circle" slot="icon"></a-icon> -->
                                          

                                      </a-step>
                                  </a-steps>
                                  <a-steps direction="vertical" :current="resultId" v-else>
                                      <a-step  v-for="(item, index) in processList" :key="index">
                                          <template slot="title">
                                              <div v-if="item">
                                                <span class="red">{{item.name}}</span>
                                                <span style="margin-left: 10px;"  v-if="item.flag == true && item.type != 'end' && item.type != 'start' ">审批结果：<span :style="{color: resultColor[item.result] }">{{resultList[item.result]}}</span></span>
                                              </div>
                                          </template>
                                          <template slot="description">
                                              <div class="red">{{item.auditor}}</div>
                                              <div v-if="item.comment">审批建议：{{item.comment}}</div>
                                          </template>
                                          <a-icon v-if="item.result == 0 && item.flag == true " type="check-circle" slot="icon"></a-icon>
                                          <!-- 通过审批 -->
                                          <a-icon v-if="item.result == 2 " type="check-circle" slot="icon"></a-icon>
                                          <!-- 驳回 -->
                                          <a-icon v-if="item.result == 3 || item.result == 4 || item.result == 6 " type="close-circle" slot="icon"></a-icon>
                                          <!-- 审批中 -->
                                          <a-icon  v-if="item.result == 1 && item.flag == true " type="clock-circle" slot="icon"></a-icon>
                                          <a-icon  v-if="item.result == 0 && item.flag == false " type="clock-circle" slot="icon"></a-icon>
                                          <!-- <a-icon   v-else type="clock-circle" slot="icon"></a-icon> -->
                                      </a-step>
                                  </a-steps>
                            </div>
                      </div>
                  </div>


              </div>
       <a-modal class="gufiiguy" title="文件管理" :visible="fileVisible" @cancel="closeRecords" width="40%">
      <template slot="footer">
        <a-button key="back" @click="fileVisible = false"> 取消 </a-button>
      </template>
      <div class="containerBottom" style="margin-bottom: 40px">
        <div style="width: 80%;">
          <div style="margin-bottom: 10px">文件预览:</div>
          <div v-if="isImg == 0">
            <div class="view_path" @click="previewFile(item)" v-for="(item, index) in appendix" :key="index">
              {{ item.name }}
            </div>
          </div>
           <div class="view_path_img_center" v-else>
            <div class="img_center" v-for="(item, index) in certificate" :key="index">
              <img :src="item.imgUrl" @click="show_img1(index, certificate)" />
            </div>
            <preview ref="preview1" />
          </div>
        </div>
      </div>
      <preview ref="preview1" />
    </a-modal>
    <!-- 评论申请 -->
    <a-modal class="gufiiguy" title="评论申请单" :visible="commentVisible" @cancel="closeComment" width="40%">
      <template slot="footer">
        <a-button key="back" @click="commentVisible = false"> 取消 </a-button>
         <a-button key="back" @click="sendCommit" type="primary"> 发送 </a-button>
      </template>
      <div class="containerBottom" style="margin-bottom: 10px">
         <a-textarea v-model="commitData" placeholder="请输入提示内容" :auto-size="{ minRows: 2, maxRows: 5 }" style="width:100%;border: 1px solid #dedfdf;height: 80px;" />
      </div>
      <preview ref="preview1" />
    </a-modal>
    <!-- 重新推送 -->
    <a-modal class="gufiiguy" :title=" typeIndex == 1? '付款单推送':'转账单推送'" :visible="rePushInfo" @cancel="closeRePush" width="40%">
      <template slot="footer">
        <a-button key="back" @click="closeRePush"> 取消 </a-button>
        <a-button  @click="sendRePush" type="primary"> 提交</a-button>
      </template>
      <div style="margin-top: 20px;">
          <a-form  class="gufiiguy">
            <a-form-model :model="reForm" ref="reFormRef" :label-col="{ span: 4 }" :wrapper-col="{ span: 20 }">
              <a-form-model-item label="户名" prop="name">
              <a-input allowClear v-model="reForm.name" placeholder="请输入" />
              </a-form-model-item>
            </a-form-model>
             <a-form-model :model="reForm" ref="reFormRef" :label-col="{ span: 4 }" :wrapper-col="{ span: 20 }">
              <a-form-model-item label="账号" prop="accountNum" >
              <a-input allowClear v-model="reForm.accountNum" placeholder="请输入" />
              </a-form-model-item>
            </a-form-model>
             <a-form-model :model="reForm" ref="reFormRef" :label-col="{ span: 4 }" :wrapper-col="{ span: 20 }" v-if="reForm.bank">
              <a-form-model-item label="银行" prop="bank" >
              <a-input allowClear v-model="reForm.bank" placeholder="请输入" />
              </a-form-model-item>
            </a-form-model>
             <a-form-model :model="reForm" ref="reFormRef" :label-col="{ span: 4 }" :wrapper-col="{ span: 20 }" v-if="reForm.address">
              <a-form-model-item label="地址" prop="address" >
              <a-input allowClear v-model="reForm.address" placeholder="请输入" />
              </a-form-model-item>
            </a-form-model>
            <a-form-model :model="reForm" ref="reFormRef" :label-col="{ span: 4 }" :wrapper-col="{ span: 20 }" v-if="reForm.branchBank">
              <a-form-model-item label="银行支行" prop="branchBank" >
              <a-input allowClear v-model="reForm.branchBank" placeholder="请输入" />
              </a-form-model-item>
            </a-form-model>
          </a-form>
      </div>
    </a-modal>

  </div>
     
</template>
<script>
import preview from '@/components/module/prview'
import { download_file_java } from '@/utils/request'
import { resolveBlob } from '@/utils/index'
import { getPaymentDetail } from '@/api/financial'
import auditModel from '../../activiti/modules/audit.vue'
import { computeLen } from '@/utils/amount'
import {	get_process_all, comment_delete, comment, repushEvent, singleTransfer} from '@/api/activiti'
export default {
  components: {
    auditModel,
    preview,
  },
  data() {
    return {
      reForm: {
        name: '',
        accountNum: '',
        bank: '',
        address: '',
        branchBank: '',
      },
      rePushInfo: false,
      isImg: 0,
      certificate: [],
      fileVisible: false,
      commitData: '',
      isError: 0,
      resultId: 0,
      resultColor: ['','#FF9959', 'green','#FF7272','#FF7272','','#919191'],
      resultList: ['','审批中','通过','驳回','撤销','','中止'],
      expandIconPosition: 'right',
      preUrl: '',  
      appendix: [],
      vouchers: [],
      fileVisible: false,
      invoiceList: ['电子增值税普通发票', '电子增值税专用发票', '增值税普通发票', '增值税专用发票'],
      detailData: [],
      type: 1,
      purchaseData: [],
      approvalData: [],
      receiptData: [{}],
      //费用明细
      costDetail: [{}],
      accountData: [
        {
          name: 1,
        },
      ],
      applyData: [
        {
          name: 1,
        },
      ],
      options: [],
      processList: [],
      processData: [],
      detailVisible: false,
      rowData: [],
      commentVisible: false,
      timeout: null,
      typeIndex: 1,
    }
  },
  methods: {
    //推送
    sendRePush() {
        //增加防抖
      if (this.timeout) {
          clearTimeout(this.timeout)
      }
      this.timeout = setTimeout(() => {
        if(this.typeIndex == 1) {
            repushEvent({
              businessKey:  this.detailData.businessKey,
              applyCode: this.detailData.applyCode,
              name: this.reForm.name,
              accountNum: this.reForm.accountNum,
              bank: this.reForm.bank,
              projectMoney: this.detailData.projectMoney,
              branchBank: this.reForm.branchBank
            }).then(res => {
              if(res.code == 200) {
                if(res.data) {
                  this.$message.success('推送成功！')
                  //值回填
                  this.detailData.paymentBillNo = res.data
                  this.closeRePush()
                }else {
                  this.$message.error('推送失败！')
                }
              }else {
                this.$message.error(res.msg)
              }
            })
        } else {
           singleTransfer({
                id: this.detailData.id,
                businessKey:  this.detailData.businessKey,
                applyCode: this.detailData.applyCode,
                name: this.reForm.name,
                accountNum: this.reForm.accountNum,
                bank: this.reForm.bank,
                projectMoney: this.detailData.projectMoney,
                branchBank: this.reForm.branchBank,
                itemCode: this.detailData.itemCode,
                budgetMoney: this.detailData.budgetMoney,
              }).then(res => {
                    if(res.code == 200) {
                      if(res.data) {
                        this.$message.success('推送成功！')
                        //值回填
                        this.detailData.serialNo = res.data
                        this.closeRePush()
                      }else {
                        this.$message.error('推送失败！')
                      }
                    }else {
                      this.$message.error(res.msg)
                    }
                  })

        }
      }, 500);

    },
    // 关闭重新推送
    closeRePush() {
      this.rePushInfo = false
      this.reForm = {
        name: '',
        accountNum: '',
        bank: '',
        address: '',
        branchBank: '',
      }
    },
    // 重新推送
    rePush(data) {
      this.typeIndex = data
      this.rePushInfo = true
      this.reForm = this.detailData.BaseInformation.account_information.reimbursement_account

    },
    // 关闭弹窗
    onClose() {
      this.detailVisible = false
    },
    //打开评论弹窗
    getCommit() {
      this.commitData = ''
      this.commentVisible = true
    },
    //发送评论
    sendCommit() {
      comment({
					procInstId:this.rowData.procInstId,
					userId:this.$store.getters.userInfo.userId,
					comment:this.commitData,
				}).then(res=>{
					if (res.code == 200) {
						this.$message.success('评论成功')
            this.commentVisible = false
            this.getProcessData(this.rowData)
					} else {
						this.$message.error(res.msg)
						return
					}
				})

    },
    //关闭审批弹窗
    closeComment() {
       this.commentVisible = false
       this.commitData = ''

    },
    //
     delTem(item){
          comment_delete(item.id).then(res=>{
                if (res.code == 200) {
                  this.$message.success('撤回成功')
                  this.getProcessData(this.rowData)
                  // this.show(this.rowlist)
                } else {
                  this.$message.error(res.msg)
                  return
                }
              })
         },

    getProcessData(row) {
      this.processList = []
      get_process_all({
					procInstId: row.procInstId,
					name: row.procDefKey,
					userId: this.$store.getters.userId,
				}).then((res) => {
          this.processData = res.data.commentList
          this.processList = res.data.tasks
          //  for(var i = 0; i < this.processList.length; i++) {
          //   if(!this.processList[i].flag) {
          //     this.resultId = i-1
          //     return
          //   }
          // }
          this.resultId = -1
          for(var i = 0; i < this.processList.length; i++) {
            console.log( this.isError , ' this.isError ====================')
            if(this.processList[i].result == 3 || this.processList[i].result ==  4 || this.processList[i].result == 6) {
              this.isError = 1
              console.log( this.isError , ' this.isError ====================')
            } 
            if(this.processList[i].flag) {
              this.resultId =  this.resultId + 1
              console.log( this.resultId, ' this.resultId======================')
            }
          }
          this.processList.splice(0,0)
          console.log(this.processList, 'this.processList==================')

        })

    },
    closeRecords() {
      this.fileVisible = false
    },
    //文件展示
    downFile(index) {
       if(this.detailData.BaseInformation.bill_information[0].bill_attach_id != '' || this.detailData.BaseInformation.bill_information[0].bill_img.length != 0  ) {
      if(this.detailData.BaseInformation.bill_information[0].bill_attach) {
         this.isImg = 0
          this.appendix = []
          var data = {
            name: this.detailData.BaseInformation.bill_information[index].bill_attach.fileName,
            id: this.detailData.BaseInformation.bill_information[index].bill_attach.id,
            url: this.detailData.BaseInformation.bill_information[index].bill_attach.path,
            types: 'bill-appendix',
            preUrl: this.detailData.BaseInformation.bill_information[index].bill_attach.url,
          }
          this.appendix.push(data)

      }else if (this.detailData.BaseInformation.bill_information[0].bill_img) {
        this.isImg = 1
        this.certificate = []
         var data = {
            imgUrl:  process.env.VUE_APP_API_BASE_URL + '/file/file/pre_file' + '?bucketName=bill-img'+'&path=' + this.detailData.BaseInformation.bill_information[index].bill_img,
            url: this.detailData.BaseInformation.bill_information[index].bill_img,
          }
          this.certificate.push(data)
      }
     
      this.fileVisible = true
       } else {
          this.$message.warning('未上传发票附件')
       }
    },
    //预览图片
    show_img(idx, imgs) {
      var row = {
        index: idx,
        imgs: imgs,
      }
      this.$refs.preview.show(row)
    },
    //预览图片
    show_img1(idx, imgs) {
      var as=[];
      imgs.forEach(element => {
        as.push( {preUrl:process.env.VUE_APP_API_BASE_URL + '/file/file/pre_file' + '?bucketName=bill-img'+'&path=' + element.url})
      });
      console.log(imgs)
      var row = {
        index: idx,
        imgs: as,
      }
      this.$refs.preview1.show(row)
    },
    //文件预览
    async previewFile(file) {
      let path = '/' + file.url.split('/')[0] + '/'
      let fileName = file.url.substring(file.url.indexOf('/') + 1)
      var res = await download_file_java(file.types, path, fileName)
      var file_s_n = file.name.split('.')
      let type = file_s_n[file_s_n.length - 1]
      resolveBlob(res, this.get_file_type[type]) //新窗口打开，借用浏览器去打印
    },
    init(data) {
      this.rowData = data
        this.isError = 0
        this.getProcessData(data)
        console.log(data, 'data=================')
      getPaymentDetail(data.businessKey).then((res) => {
        if (res.code == 200) {
          // var array = []
          // array.push(res.data.BaseInformation.information_relate)
          // res.data.BaseInformation.information_relate = array
          Object.assign(res.data,{
              capitalMoney: computeLen(res.data.projectMoney)
          })
          var list = []
          for(var i = 0; i < res.data.detail.length; i++) {
             var data = {
                      value: '',
                      array: [],
                      control_name: '',
                  }
              data.control_name = res.data.control_name[i]
              console.log(data, 'data===============')
             for(var j = 0; j < res.data.detail[i].length; j++) {
                 if(res.data.detail[i][j]) {
                    console.log(res.data.detail[i][j], 'res.data.detail[i][j]============')
                    if(res.data.detail[i][j].index_name == 'detail_money') {
                          data.value = res.data.detail[i][j].value,
                          res.data.detail[i].splice(j,1)
                          data.array = res.data.detail[i]
                           console.log(res.data.detail[i], 'res.data.detail[i]111111============')
                    }
                 }
                  
             }
            // }
           list.push(data) 
          }
          res.data.detail =  list
          this.detailData = res.data
          // console.log(this.detailData.detail,'','this.detailData===================')
          // this.detailData.detail.forEach(item=> {
          //   console.log(item,item.array, 'item=========================')
          // })
          this.detailVisible = true
          
        //   setTimeout(() => {
        //     this.$refs.auditModel.show({
        //       businessKey: data.id,
        //       procInstId: data.procInstId,
        //       procDefKey: data.procDefKey,
        //       recordNumber: 1,
        //     })
        //   }, 1000)
        }
      })
    

      //  const modal = modalMap[row.procDefKey]
    },
    onClose() {
      this.processList = []
      this.detailVisible = false
    },
  },
}
</script>

<style lang="less" scoped>
.box {
  margin-top: 10px;
  .title {
       font-weight: 700;
       color: black;

  }
}
.centerBox {
  margin-top: 10px;
//   padding: 10px;
  // box-shadow: rgba(0, 0, 0, 0.15) 0px 5px 15px 0px;
  border-radius: 5px;
}
.containerTop {
  font-weight: 700;
  /* float: left; */
  margin: 0;
  padding: 25px 0 10px 20px;
  color: black;
  font-size: 18px;
  border-bottom: 1px solid rgb(230, 228, 228);
}
.lineBox {
    display: flex;
    justify-content: space-between;

}
.containerBottom {
  padding: 10px 20px;
  display: flex;
  justify-content: space-between;
  
  .left {
      width: 55%;
      .lineBox {
        margin-top: 10px;
        display: flex;
        justify-content: space-between;
   }


  }
  .right {
    //   margin-left: 20px;
      width: 45%;
        .containerBox {
          display: flex;
          justify-content: space-between;
          .containerLeft {
            border: 1px solid rgb(230, 228, 228);
            display: flex;
            justify-content: space-between;
            width: 70%;
            .first {
              width: 24px;
              margin: 9px;
              padding: 10px 2px;
              color: black;
              border-right: 1px solid rgb(230, 228, 228);
            }
            .second {
              width: 90%;
              margin: 9px;
              display: flex;
              flex-direction: column;
              align-self: center;

            }
          }
          .containerRight {
            margin-left: 10px;
            width: 30%;
            img {
              // height: 100%;
              width: 80%;
              // object-fit: cover;
	            cursor: pointer;

            }

          }

      }

  }
}
.boxBorder {
    border-top: 1px solid rgb(230, 228, 228);
    // background-color: #eef1f2;

}
.containerCenter {
    margin: 10px 0 10px 0;
    display: flex;
    justify-content: space-between;
    overflow-y: hidden;

    .left {
        padding: 0 15px;
        height: 800px;
        width: 65%;
        overflow-y: scroll;
    }
    .right {
          height: 800px;
          width: 35%;
          padding: 10px;
          // background-color: rgb(185, 232, 245);
          overflow-y: scroll


    }

}
// .title {
//   font-weight: 700;
//   color: black;
// }
.center {
  margin-top: 130px;
  margin-bottom: 50px;
  .centerInform {
    .content {
      padding: 20px;
      box-shadow: rgba(0, 0, 0, 0.15) 0px 5px 15px 0px;
      border-radius: 5px;
      margin-top: 10px;
      .contentTop {
        display: flex;
        justify-content: space-between;
      }
      .left {
        height: 50px;
        width: 30%;
        background-color: #eef1f2;
        line-height: 50px;
        text-align: center;
      }
      .right {
        height: 50px;
        width: 70%;
        line-height: 50px;
        text-align: center;
    
      }
      .top,
      .bottom {
        width: 100%;
        height: 50px;
        line-height: 50px;
        text-align: center;
      }
      .top {
        border-top: 1px solid rgb(230, 228, 228);
        background-color: #eef1f2;
      }
    }
  }
}
.costCenter {
  .detail {
    margin: 10px 5px;
    padding: 10px;
    .bottom {
      padding: 20px;
    }
  }
}
.receiptDetail {
  margin-top: 10px;
  .center {
    margin-top: 10px;
  }
}
.applyDetail {
  margin-top: 10px;
  .content {
    margin-top: 10px;
  }
}
.countDetail {
  margin-top: 10px;
  .content {
    padding: 10px;
  }
}
.examineDetail {
  margin-top: 10px;
  .content {
    margin-top: 10px;
    padding: 10px;
    box-shadow: rgba(0, 0, 0, 0.15) 0px 5px 15px 0px;
    border-radius: 5px;
  }
}
.contentBox {
  padding: 10px;
  // display: flex;
  // justify-content: space-between;
  // .rightBox,
  // .leftBox {
  //   padding: 5px;
  //   width: 50%;
  // }
  .img_center {
    width: 23%;
    margin: 20px 5px;
    position: relative;
    // float: left;
    display: inline-block;
    height: 60px;
 
        img {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            object-fit: cover;
        }
        .timeBox {
           position: absolute;
            bottom: -60px;
            left: 0;
            width: 100%;
            height: 100%;

        }
  }
}
 .expensesTitle {
    margin-bottom: 10px;
    color: black;
    margin-right: 5px;
    width: 15%
    }
    .travelBoxTop {
    border: 1px solid #dedfdf;
    height: 100px;
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
}
 .travelContetTop {
            background-color: #EDF1F2 ;
            height: 51px;
            line-height: 50px;
            text-align: center;
            // box-sizing: border-box;

        }
 .borderStyle {
      border-left: 1px solid #dedfdf;
      border-right: 1px solid #dedfdf;
        }
 .borderBottom {
      border-bottom: 1px solid #dedfdf;
 }
.layoutbox {
        display: flex; 
        flex-direction: row; 
        flex-wrap: nowrap;
        border-Top: 1px solid #dedfdf;
        // box-sizing: border-box;

}
.travelContetBottom {
    padding: 10px;
    height: 50px;
    span {
      display: inline-block;
      width: 100%;
      text-align: center;
    }
}
.travelBoxCenter {
    height: 153px;
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    // box-sizing: border-box;

}
.travelCenter {
    height: 50px;
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
   .contener {
       line-height: 49px;
       text-align: center;
       width: 18%;
       border-right: 1px solid #dedfdf;
       background-color: #EDF1F2
       
   }
   .contenerBox {
      width: 32%;
      border-right: 1px solid #dedfdf;

   }
   .contenerCenter {
      width: 40%;
      padding: 10px;
      border-right: 1px solid #dedfdf;
       
   }

}
.xuxian{
    width: 55%;
    height:0;
    border-bottom: #BBBBBB  1px dashed;
    margin: 12px 0;
    }
.expensesTop {
    padding: 10px 10px 0px 10px;
    display: flex;
    justify-content: space-between;

}
.view_path_img_center {
  img {
    width: 30%;
    object-fit: cover;

  }
}
</style>
